<template>
  <div>
    <!-- <div class="text-xs-center email-registration__title">Login</div> -->
    <v-form class="email-login__form-container">
      <div class="error--text" v-if="errors.email">
        <div v-for="(error, index) in errors.email" :key="index">
          {{ error }}
        </div>
      </div>
      <v-text-field
        dark
        name="email"
        v-model="email"
        label="E-mail"
      ></v-text-field>
    
      <div class="error--text" v-if="errors.password">
        <div v-for="(error, index) in errors.password" :key="index">
          {{ error }}
        </div>
      </div>
      <v-text-field
        dark
        name="password"
        v-model="password"
        label="Password"
        type="password"
      ></v-text-field>
    
      <div class="error--text">
        <div v-for="(error, index) in errors.non_field_errors" :key="index">
          {{ error }}
          <span v-if="error == 'E-mail is not verified.'">
            <v-btn flat @click="resendVerifyEmail">
              Resend verification email
            </v-btn>
          </span>
        </div>
      </div>
      <v-btn flat class="email-login__login-button mb-5" :loading="loginEmailRedirecting" id="authBtn-login" @click.native="loginEmailPassword"><p>Login</p></v-btn>
      <br>
      <v-btn flat class="email-login__redirect-registration-button mt-5" @click="setUrlHash('register')" id="authBtn-registerEmail"><p>Don't have an account? Sign up!</p></v-btn>
      <br>
      <v-btn flat class="email-login__redirect-registration-button" @click="setUrlHash('resetpassword')">
        <p>Forgot password?</p>
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      email: '',
			password: '',
      confirm_password: '',
			errors: {},      
      loginEmailRedirecting: false
    }
  },
  methods: {
    ...mapActions([
			'setAuthModalOpen',
			'setAuthRedirect',
			'setToken',
			'setUserSocial'
		]),
    loginEmailPassword() {
			this.loginEmailRedirecting = true
			axios
				.post('/rest-auth/login/', {
					email: this.email,
					username: this.email,
					password: this.password
				})
				.then(response => {
					this.setAuthModalOpen(false)
					this.setToken(response.data.token)
					axios.defaults.headers.common['Authorization'] =
						'Bearer ' + response.data.token
					this.setUserSocial(response.data.user)
					if (response.data.user.active === false) {
						window.location = '/user/confirmation'
					} else {
						if (this.getAuthRedirect) {
							this.setAuthRedirect(null)
							window.location = this.getAuthRedirect
						} else {
							window.location = '/'
						}
					}
					this.loginEmailRedirecting = false
				})
				.catch(error => {
					this.loginEmailRedirecting = false
					console.error('Error')
					this.errors = error.response.data
					console.error(error)
					console.error(error.response)
				})
    },
    setUrlHash(hash) {
      window.location.hash = hash
    }
  }
}
</script>

<style lang="scss">
.email-login__form-container {
  padding: 0 10px;
}
.email-login__title {
  color: #EEE!important;
  font-family: 'Nunito', sans-serif;
  font-weight: 200;
  font-size: 2.0em;
  margin-bottom: 30px;
}
.email-login__redirect-registration-button {
  color: white!important;
  p {
    color: #FFF!important;
    font-family: 'Nunito', sans-serif;
    font-weight: 200;
    margin: 0;
  }
}
.email-login__login-button {
  color: white!important;
  border: 1px solid white;
  border-radius: 0;
  width: 150px;
  height: 50px;
  p {
    color: white!important;
    margin: 0;
    font-family: 'Nunito', sans-serif;
    font-weight: 200;
    font-size: 1.1em;
  }
  margin-bottom: 15px;
}
</style>
